import { apiClient } from './apiClient';

const createChaosWidget = async () => {
  return await apiClient.post('/dashboard/chaos-widget');
};

const fetchChaosWidgets = async () => {
  return await apiClient.get('/dashboard/chaos-widget');
};

const updateChaosWidget = async (id, payload) => {
  return await apiClient.patch(`/dashboard/chaos-widget/${id}`, payload);
};

const fetchPublicChaosWidget = async (uuid) => {
  return await apiClient.get(`/chaos-widget/${uuid}`);
};

export const chaosWidgetApi = {
  createChaosWidget,
  fetchChaosWidgets,
  updateChaosWidget,
  fetchPublicChaosWidget
};
